// Le hook React autour de src/panier.js.
//
// Il garde la liste des commandes cochees dans le navigateur (Simon a decide
// qu'elle survit au rechargement de la page) et il la REVALIDE a chaque
// changement de la liste des commandes ou du verrou.
//
// Aucune regle metier ici : elles sont toutes dans src/panier.js, qui se prouve
// sans monter un composant. Ce fichier ne fait que brancher React dessus.

import { useCallback, useEffect, useState } from "react";
import { lire, ecrire, revalider } from "../panier";

// Le localStorage peut etre INTERDIT (navigation privee, cookies bloques) :
// y toucher jette alors, avant meme getItem. lire() et ecrire() avalent deja
// l'erreur, mais encore faut-il pouvoir leur passer quelque chose.
function stockage() {
  try {
    return typeof window !== "undefined" ? window.localStorage : null;
  } catch (e) {
    return null;
  }
}

// `pret` dit si la revalidation a de quoi travailler : la liste des commandes
// est bien celle de la base, ET le verrou a ete lu.
//
// 🔴 SANS CE GARDE-FOU, LE PANIER SE VIDE A CHAQUE F5. La liste des commandes
// demarre a [] (ou a une copie en memoire) le temps que la vraie arrive. Une
// revalidation lancee a ce moment-la ne trouve AUCUNE commande et les retire
// toutes, avec le motif « n'existe plus ou n'est plus visible » — un message
// faux, dans la seule phrase dont le travail est de dire la verite a Simon.
export default function usePanier(commandes, commandesVerrouillees, pret) {
  // La liste survit au rechargement : on la relit au premier rendu.
  const [ids, setIds] = useState(() => lire(stockage()));
  // Les commandes sorties du panier, avec leur raison. Elles s'accumulent
  // jusqu'a ce que Simon les acquitte : jamais de retrait silencieux.
  const [retires, setRetires] = useState([]);

  // Une seule facon d'ecrire dans le navigateur : l'etat mene, le stockage
  // suit. Ainsi aucun chemin de code ne peut mettre les deux en desaccord.
  useEffect(() => {
    ecrire(stockage(), ids);
  }, [ids]);

  useEffect(() => {
    if (pret !== true) return;
    const { ids: gardes, retires: sortis } = revalider(ids, commandes, commandesVerrouillees);
    // Rien a retirer : on ne touche a rien. C'est AUSSI ce qui empeche la
    // boucle infinie — revalider rend un tableau NEUF a chaque appel, et le
    // poser dans l'etat relancerait cet effet pour toujours.
    if (sortis.length === 0) return;
    setIds(gardes);
    setRetires(anciens => anciens.concat(sortis));
  }, [pret, ids, commandes, commandesVerrouillees]);

  const basculer = useCallback(id => {
    const propre = typeof id === "string" ? id.trim() : "";
    if (!propre) return;
    setIds(avant => (avant.includes(propre) ? avant.filter(x => x !== propre) : avant.concat([propre])));
  }, []);

  // Vider ne fabrique AUCUN retrait : c'est Simon qui l'a demande, il n'a rien
  // a apprendre. Et les retraits deja affiches restent : ils expliquent une
  // chose qui s'est bel et bien passee.
  const vider = useCallback(() => setIds([]), []);

  const acquitterRetires = useCallback(() => setRetires([]), []);

  return { ids, basculer, vider, retires, acquitterRetires };
}
